module.exports = __webpack_public_path__ + "static/img/pma.e344693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pma.jpg
// module id = gI65
// module chunks = 0